import React from 'react';
import DataSourcesPage from './DataSourcesPage';

const ChrisPropertiesPage: React.FC = () => (
  <DataSourcesPage
    title="CHRIS Properties"
    itemLabel="CHRIS Property"
    addButtonLabel="Add CHRIS Property"
    source="CHRIS"
    columns={[
      { key: 'type', label: 'Inventory Type' },
      { key: 'property', label: 'Property' },
      { key: 'name', label: 'Name' },
      { key: 'code', label: 'Code' }
    ]}
    fields={[
      { key: 'type', label: 'Inventory Type', required: true },
      { key: 'property', label: 'Property', required: true },
      { key: 'name', label: 'Name', required: true },
      { key: 'code', label: 'Code', required: true }
    ]}
  />
);

export default ChrisPropertiesPage;
